import { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import useQuery from '../../hooks/useQuery'

import Content from './Components/Content'
import Menu from './Components/Menu'
import Search from './Components/Search'
import { getOrders, getOrdersByStatus, getOtherOrders, lockOrder, getOrdersLocked } from './Services/serviceAdmin'
import { getRemainingAmount, getAllSlipInOrder } from './Services/servicePayment'

const OrderSlot = () => {
  const [status, setStatus] = useState('OPEN')
  const [orders, setOrders] = useState([])
  const [order, setOrder] = useState({})
  const [slips, setSlips] = useState([])
  const [triggerSearch, setTriggerSearch] = useState(false)
  const [remainingAmount, setRemainingAmount] = useState(undefined)
  const [otherOrders, setOtherOrders] = useState([])
  const [lockedId, setLockedId] = useState('')
  const dispatch = useDispatch()

  const query = useQuery()

  const searchpage = Number(query.get('searchpage') || 1)

  const fetchOrdersByStatus = async (status, page = 1) => {
    dispatch({ type: 'loading_show' })
    let allOrder = await getOrdersByStatus(status, status === 'CONFIRMED' ? false : undefined, page)
    if (status !== 'SUCCESS') {
      allOrder = allOrder.filter((v) => !v.isIssue)
    }

    const selectedOrder = allOrder[0]
    const { userInfo: { userNo } = {} } = selectedOrder || {}
    status === 'CONFIRMED' && (await lockOrder(selectedOrder?.id))
    const others = await getOtherOrders(userNo)
    allOrder = await fetchSlipsAndAmount(allOrder, selectedOrder)

    setStatus(status)
    setOrders(allOrder)
    setOrder(selectedOrder)
    setOtherOrders(others)
    dispatch({ type: 'loading_hide' })
  }

  const fetchOrdersLocked = async () => {
    const allOrder = await getOrdersLocked()
    await updateAllState(allOrder)
  }

  const fetchOrdersIssue = async () => {
    const response = await getOrdersByStatus('CONFIRMED', true)

    await updateAllState(response)
  }

  const fetchOrderAferUpdateStatus = async (status) => {
    switch (status) {
      case 'LOCKED':
        await fetchOrdersLocked()
        break
      case 'ISSUE':
        await fetchOrdersIssue()
        break
      case 'SEARCH':
        setTriggerSearch(true)
        break
      default:
        await fetchOrdersByStatus(status)
        break
    }
  }

  // to refactor น่าจะแยกได้ระหว่าง api slip, amount, transaction แล้วนำข้อมูลมา setState ที่ละตัว
  // ชื่อ func น่าจะสื่อความหมายมากกว่านี้
  const fetchSlipsAndAmount = async (allOrder, selectedOrder) => {
    const allSlip = await getAllSlipInOrder(selectedOrder?.orderId)
    let remainAmount = undefined

    if (allSlip?.length > 0) {
      const remaining = await getRemainingAmount(allSlip[0]?.id)
      remainAmount = remaining?.remainingAmount
      if (remainAmount <= 0 && selectedOrder?.status !== 'SUCCESS') {
        allOrder = allOrder?.filter((v) => v.id !== order?.id)
      }
    }

    setSlips(allSlip)
    setRemainingAmount(remainAmount)
    return allOrder
  }

  const searchOrders = async (status, params) => {
    dispatch({ type: 'loading_show' })
    let allOrder = await getOrders(params)
    const selectedOrder = allOrder[0]

    selectedOrder?.status === 'CONFIRMED' && (await lockOrder(selectedOrder?.id))

    const { userInfo: { userNo } = {} } = selectedOrder || {}

    const others = await getOtherOrders(userNo)
    allOrder = await fetchSlipsAndAmount(allOrder, selectedOrder)

    setStatus(status)
    setOrders(allOrder)
    setOrder(selectedOrder)
    setOtherOrders(others)
    dispatch({ type: 'loading_hide' })
  }

  const updateAllState = async (allOrder) => {
    dispatch({ type: 'loading_show' })
    let remainAmount = undefined
    let newAllOrder = [...allOrder]
    const selectedOrder = allOrder[0]

    const { userInfo: { userNo } = {} } = selectedOrder || {}

    const others = await getOtherOrders(userNo)
    const allSlip = await getAllSlipInOrder(selectedOrder?.orderId)

    if (allSlip?.length > 0) {
      const remaining = await getRemainingAmount(allSlip[0]?.id)
      remainAmount = remaining?.remainingAmount
      if (remainAmount <= 0 && selectedOrder?.status !== 'SUCCESS') {
        newAllOrder = allOrder?.filter((v) => v.id !== order?.id)
      }
    }

    setOrders(newAllOrder)
    setOrder(selectedOrder)
    setSlips(allSlip)
    setRemainingAmount(remainAmount)
    setOtherOrders(others)
    dispatch({ type: 'loading_hide' })
  }

  useEffect(() => {
    fetchOrdersByStatus(status)
  }, [])

  return (
    <>
      <Menu
        order={order}
        status={status}
        setStatus={setStatus}
        setOrders={setOrders}
        setOrder={setOrder}
        setSlips={setSlips}
        setOtherOrders={setOtherOrders}
        setRemainingAmount={setRemainingAmount}
        fetchOrdersByStatus={fetchOrdersByStatus}
        updateAllState={updateAllState}
      />
      <Search
        setStatus={setStatus}
        searchOrders={searchOrders}
        triggerSearch={triggerSearch}
        setTriggerSearch={setTriggerSearch}
        fetchOrdersByStatus={fetchOrdersByStatus}
        page={searchpage}
      />
      <Content
        status={status}
        orders={orders}
        order={order}
        slips={slips}
        remainingAmount={remainingAmount}
        otherOrders={otherOrders}
        setSlips={setSlips}
        setOrders={setOrders}
        setOrder={setOrder}
        setOtherOrders={setOtherOrders}
        setRemainingAmount={setRemainingAmount}
        fetchOrdersByStatus={fetchOrdersByStatus}
        fetchOrderAferUpdateStatus={fetchOrderAferUpdateStatus}
      />
    </>
  )
}

export default OrderSlot
